import * as React from "react";
const SvgFiRrMapMarkerEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 24a5.41 5.41 0 0 1-3.807-1.552L4.25 18.805C2.144 16.7 1 13.938 1 11s1.144-5.701 3.222-7.778A10.93 10.93 0 0 1 12 0c2.938 0 5.7 1.144 7.778 3.222A10.92 10.92 0 0 1 23 11c0 2.939-1.144 5.7-3.222 7.778l-3.992 3.689A5.4 5.4 0 0 1 12 24m0-22a8.94 8.94 0 0 0-6.364 2.636A8.94 8.94 0 0 0 3 11a8.94 8.94 0 0 0 2.636 6.364l3.936 3.635c1.336 1.306 3.542 1.286 4.837.02l3.984-3.682A8.92 8.92 0 0 0 21 11.001a8.95 8.95 0 0 0-2.636-6.364A8.94 8.94 0 0 0 12 2M9.172 16H8a1 1 0 0 1-1-1v-1.171c0-1.335.521-2.591 1.465-3.536l3.414-3.414A3.002 3.002 0 0 1 17 9c0 .801-.313 1.555-.879 2.122l-3.414 3.414A4.97 4.97 0 0 1 9.172 16M9 14h.172c.79 0 1.562-.32 2.121-.878l3.414-3.415A1 1 0 0 0 15 9a1 1 0 0 0-1.707-.707l-3.414 3.414A2.98 2.98 0 0 0 9 13.829z"
    />
  </svg>
);
export default SvgFiRrMapMarkerEdit;
